const defaultItem = {
  dismissible: true,
  timeout: 5000,
  callbackCalled: false,
}

let count = 0

export default {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    ITEM_ADDED(state, item) {
      count += 1
      item = Object.assign(item, { id: count })
      const newItems = state.items.map((i) => i)
      newItems.push(item)
      state.items = newItems
    },
    ITEM_REMOVED(state, item) {
      state.items = state.items.filter((i) => i !== item)
    },
    CALLBACK_CALLED(state, item) {
      item.callbackCalled = true
    },
  },
  actions: {
    addItem({ commit }, item) {
      item = Object.assign({}, defaultItem, item)
      commit('ITEM_ADDED', item)
      if (item.timeout) {
        setTimeout(() => {
          commit('ITEM_REMOVED', item)
        }, item.timeout)
      }
    },
    removeItem({ commit }, item) {
      commit('ITEM_REMOVED', item)
      if (item.onRemove) {
        item.onRemove(item)
      }
    },
    callbackCalled({ commit }, item) {
      commit('CALLBACK_CALLED', item)
    },
  },
}
